<template>
  <div :key="keyUnico" id="resultadoPases">
    <v-container grid-list-md text-xs-center fluid>
      <v-layout row wrap>
        <v-flex xs3 class="d-none d-lg-block">
          <v-card class="pa-2">
            <BuscadorPases :plano="'column'" :soloTickets="true" :isAsync="false"></BuscadorPases>
          </v-card>
        </v-flex>
        <v-flex xs12 lg9>
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-card v-if="pases.length > 0">
                <ContenedorRsPasesHoteles :data="{ pases: pases }"></ContenedorRsPasesHoteles>
              </v-card>
              <v-alert :value="true" type="warning" v-else>
                No encontramos tickets disponibles con la fecha seleccionada.
              </v-alert>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from "vuex"
import ContenedorRsPasesHoteles from "@/components/pases/ContenedorRsPasesHoteles.vue"
import BuscadorPases from "@/components/pases/BuscadorPases.vue"
import moment from "moment"
export default {
  name: "resultadoPases",
  props: ["data"],
  components: {
    BuscadorPases,
    ContenedorRsPasesHoteles
  },
  mounted() {
    this.manejoRs()
  },
  created() {},
  activated() {
    this.manejoRs()
    this.prepararContinuar()
    this.$forceUpdate()
  },
  data: function() {
    return {
      pases: [],
      keyUnico: null
    }
  },
  methods: {
    manejoRs() {
      try {
        if (this.data.rs.disponibilidad) {
          this.manejoRsOk(this.data.rs.disponibilidad)
          this.setKeyUnico()
        }
      } catch (e) {
        if (this.pases.length === 0) {
          console.log(e)
          this._$goToInicio()
        }
      }
    },
    manejoRsOk(pases) {
      this.pases = pases
    },
    setKeyUnico() {
      this.keyUnico = moment().unix()
    },
    prepararContinuar() {
      console.log("prepararContinuar")
      var btnmsg = "¡Seleccione un ticket!"
      var variant = "orange"
      let disabled = true
      let goto = null
      if (this.servicios.tickets.length != 0) {
        btnmsg = "Ingresar datos de los pasajeros"
        variant = "primary"
        disabled = false
        goto = "pasajerosCupoAgencias"
      }
      const boton = this._$toBotonCarrito(btnmsg, goto, variant, disabled)
      this.$store.dispatch("carrito/saveBoton", boton)
      return this._$toBotonCarrito(btnmsg, goto, variant, disabled)
    }
  },
  computed: {
    continua: function() {
      var btnmsg = "¡Seleccione un ticket!"
      var variant = "orange"
      let disabled = true
      let goto = null
      if (this.servicios.tickets.length != 0) {
        btnmsg = "Ingresar datos de los pasajeros"
        variant = "primary"
        disabled = false
        goto = "pasajerosCupoAgencias"
      }
      return this._$toBotonCarrito(btnmsg, goto, variant, disabled)
    },
    ...mapGetters("carrito", {
      servicios: "cartServicios"
    })
  },
  watch: {
    continua(newCount) {
      this.$store.dispatch("carrito/saveBoton", newCount)
    }
  }
}
</script>
<style scoped="">
.badge-as {
  border-radius: 0;
}
</style>
